import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import DefaultImage from '../SectionedItems/ActorItem/Default-Actor-Image.png';

const CharacterList = ({ characters, selectedIds, onClick, loading }) => {
  if (loading) {
    return [1, 2, 3, 4, 5].map(() => (
      <div className="tvt-reactions__character-loading" />
    ));
  }

  if (!characters) {
    return null;
  }
  const totalVotes = characters.reduce((total, c) => total + c.votes, 0);

  const onClickCharacter = id => () => onClick(id);

  const defaultImageFunc = e => {
    e.target.onerror = null;
    e.target.src = DefaultImage;
    e.target.srcSet = DefaultImage;
  };

  return (
    <div className="tvt-reactions__character-list-wrapper">
      {characters.map(character => (
        <button
          alt="character"
          onClick={onClickCharacter(character.id)}
          className={`tvt-reactions__character-wrapper ${selectedIds.includes(
            character.id
          ) && 'selected'}`}
        >
          <img
            alt={character.name}
            className="tvt-reactions__character-image"
            src={character.image || DefaultImage}
            onError={defaultImageFunc}
          />
          <div className="tvt-reactions__character-name-wrapper">
            <div className="tvt-reactions__character-name">
              {character.name}
            </div>
            <div className="tvt-reactions__actor-name">
              {character.actorName}
            </div>
          </div>
          <div className="tvt-reactions__character-bar-wrapper">
            <div
              className="tvt-reactions__character-votes-bar"
              style={{
                width: `${Math.floor((character.votes / totalVotes) * 100)}%`
              }}
            />
          </div>
          <div className="tvt-reactions__character-votes-wrapper">
            <div>{numeral(character.votes).format(',')}</div>
            <div>Reactions</div>
          </div>
        </button>
      ))}
    </div>
  );
};

CharacterList.propTypes = {
  characters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  onClick: PropTypes.func.isRequired
};

CharacterList.defaultProps = {
  selectedIds: []
};

export default CharacterList;
